import { render, staticRenderFns } from "./view-report.vue?vue&type=template&id=54a67a2b&"
import script from "./view-report.vue?vue&type=script&lang=js&"
export * from "./view-report.vue?vue&type=script&lang=js&"
import style0 from "./view-report.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports